export const SMS_SYSTEM_DELETE_OPEN_MODAL = "SMS_SYSTEM_DELETE_OPEN_MODAL";
export const SMS_SYSTEM_DELETE_REQUEST = "SMS_SYSTEM_DELETE_REQUEST";
export const SMS_SYSTEM_DELETE_RESULT = "SMS_SYSTEM_DELETE_RESULT";